const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'companies',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.companies" */ '@/views/Companies'),
  },
  meta: {
    breadcrumb: {
      label: 'Companies',
    },
  },
  children: [
    {
      path: '',
      name: 'companies-listing',
      component: () => import(/* webpackChunkName: "module.companies.list" */ '@/modules/Companies/List'),
      meta: {
        breadcrumb: {
          label: 'Companies',
        },
      },
    },
    {
      path: ':id/edit',
      name: 'companies-edit',
      component: () => import(/* webpackChunkName: "module.companies.edition" */ '@/modules/Companies/Edition'),
      meta: {
        breadcrumb: {
          parent: 'companies-listing',
          label: 'Edit Company',
        },
      },
    },
    {
      path: 'create',
      name: 'companies-create',
      component: () => import(/* webpackChunkName: "module.companies.edition" */ '@/modules/Companies/Edition'),
      meta: {
        breadcrumb: {
          parent: 'companies-listing',
          label: 'Create Company',
        },
      },
    },
  ],
};
